export default "/images/vendor/@material-design-icons/svg/filled/circle.svg?5eaf342c7ac57ef9c81f285ad7a96b94";